<template>
  <q-btn-dropdown
    v-if="!hideHeading"
    dense
    flat
    :size="size"
    icon="mdi-format-size"
    :label="showHeadingLabel ? activeHeadingOption.label : undefined"
    :disable="disable"
    :color="headingActionColor"
  >
    <q-list dense>
      <q-item
        v-for="option in headingOptions"
        :key="option.name"
        v-close-popup
        clickable
        :active="option.isActive()"
        active-class="text-primary"
        @mousedown.prevent="option.run"
      >
        <q-item-section avatar>
          <q-icon :name="option.icon" />
        </q-item-section>

        <q-item-section>
          {{ option.label }}
        </q-item-section>
      </q-item>
    </q-list>

    <q-tooltip>Text style</q-tooltip>
  </q-btn-dropdown>

  <q-btn
    v-for="action in toolbarActions"
    :key="action.name"
    dense
    flat
    :size="size"
    :icon="action.icon"
    :disable="disable"
    :color="getActionColor(action)"
    @mousedown.prevent="action.run"
  >
    <q-tooltip>{{ action.label }}</q-tooltip>
  </q-btn>
</template>

<script setup lang="ts">
export interface MarkdownEditorAction {
  name: string
  label: string
  icon: string
  isActive: () => boolean
  run: () => void
}

const {
  size,
  showHeadingLabel = false,
  hideHeading = false,
  disable = false,
} = defineProps<{
  size: string
  showHeadingLabel?: boolean
  hideHeading?: boolean
  disable?: boolean
  headingActionColor: string
  activeHeadingOption: MarkdownEditorAction
  headingOptions: MarkdownEditorAction[]
  toolbarActions: MarkdownEditorAction[]
}>()

function getActionColor(action: MarkdownEditorAction) {
  return action.isActive() ? 'primary' : 'secondary'
}
</script>
